/**
 * MailshotSentStatusBadge Component
 *
 * Displays whether a mailshot has been sent or is still pending.
 * Uses centralized configuration from badgeConfig.js to ensure consistency.
 */

import React from "react";
import { Badge } from "./Badge";
import PropTypes from "prop-types";
import { getMailshotStatusConfig } from "../../tools/properties/badgeConfig";
import "./MailshotSentStatusBadge.scss";

export const MailshotSentStatusBadge = ({
  mailedOut,
  status,
  size = "medium",
  showIcon = true,
  className = "",
}) => {
  // Accept either mailedOut boolean or status string
  const statusValue = status || mailedOut;
  const config = getMailshotStatusConfig(statusValue);
  const Icon = showIcon && config.icon ? config.icon : null;

  return (
    <Badge
      variant={config.variant}
      size={size}
      className={`mailshot-sent-status-badge ${className}`}
    >
      {Icon && <Icon style={{ marginRight: "0.25rem" }} />}
      {config.label}
    </Badge>
  );
};

MailshotSentStatusBadge.propTypes = {
  mailedOut: PropTypes.bool,
  status: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  showIcon: PropTypes.bool,
  className: PropTypes.string,
};

export default MailshotSentStatusBadge;
